import React from "react";

import BaseComponent from "../../baseComponent.js";
import WidgetType from "../../../core/constants/widgetType";
import styles from "./widget-list.scss";

const donutChartImg = require('file!../../../img/demo/Donut.png');
const gaugeChartImg = require('file!../../../img/demo/Gauge.png');
const textualChartImg = require('file!../../../img/demo/Textual.png');
const barLineChartImg = require('file!../../../img/demo/BarLine.png');
const tableImge = require('file!../../../img/table.png');
const treeMapImg = require('file!../../../img/demo/treemap.png');
const taChart = require('file!../../../img/demo/techan.png');
const verticalChartImg = require('file!../../../img/demo/vertical2.png');
const stackedBarImg = require('file!../../../img/stacked-bar-widget.png');
const inputControlImg = require('file!../../../img/input-control.png');
const selectionControlImg = require('file!../../../img/selection-control.png');
const datasetControlImg = require('file!../../../img/dataset-control.png');
const rankingImg = require('file!../../../img/ranking-widget.png');
const separatorImg = require('file!../../../img/separator.png');

const visualWidgets = [
  {
    title: "DONUT",
    widgetType: WidgetType.PIE_CHART,
    image: donutChartImg,
  },
  {
    title: "GAUGE",
    widgetType: WidgetType.GAUGE,
    image: gaugeChartImg,
  },
  {
    title: "TEXT",
    widgetType: WidgetType.TEXTUAL,
    image: textualChartImg,
  },
  {
    title: "TIME SERIES",
    widgetType: WidgetType.TIME_SERIES,
    image: barLineChartImg
  },
  {
    title: "TIME SERIES(VERTICAL)",
    widgetType: WidgetType.TIME_SERIES_VERTICAL,
    image: verticalChartImg,
  },
  {
    title: "Technical Analysis",
    widgetType: WidgetType.TECHNICAL_ANALYSIS_CHART,
    image: taChart
  },
  {
    title: "TABLE",
    widgetType: WidgetType.TABLE,
    image: tableImge,
  },
  {
    title: "TREE MAP",
    widgetType: WidgetType.TREE_MAP,
    image: treeMapImg
  },

  {
    title: "Stacked Bar",
    widgetType: WidgetType.BULLET_VERTICAL,
    image: stackedBarImg
  },
  {
    title: "Ranking",
    widgetType: WidgetType.RANK_WIDGET,
    image: rankingImg
  },
  {
    title: "SEPARATOR(VERTICAL)",
    widgetType: WidgetType.SEPARATOR_VERTICAL,
    image: separatorImg
  }
];

const dataWidgets = [
  {
    title: "Data entry",
    widgetType: WidgetType.CONTROL_WIDGET,
    widgetSubType: "input",
    image: inputControlImg
  },
  {
    title: "Selection",
    widgetType: WidgetType.CONTROL_WIDGET,
    widgetSubType: "selection",
    image: selectionControlImg
  },
  {
    title: "Dataset ",
    widgetType: WidgetType.CONTROL_WIDGET,
    widgetSubType: "dataset",
    image: datasetControlImg
  }
]

export default class WidgetList extends BaseComponent {
  render() {
    return (
      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <div>
          <div className={styles.widgetType}>VISUAL WIDGETS</div>
          <div className={styles.visualWidgets}>

            {
              visualWidgets.map((op, index) => {
                return <WidgetOption title={op.title}
                                     widgetType={op.widgetType}
                                     widgetSubType={op.widgetSubType}
                                     onClick={this.props.onClick}
                                     image={op.image}
                                     style={op.style}
                                     key={index}/>
              })
            }
          </div>
        </div>
        <div className={styles.separator}/>
        <div>
          <div className={styles.widgetType}>DATA WIDGETS</div>
          <div className={styles.dataWidgets}>
            {
              dataWidgets.map((op, index) => {
                return <WidgetOption title={op.title}
                                     widgetType={op.widgetType}
                                     widgetSubType={op.widgetSubType}
                                     onClick={this.props.onClick}
                                     image={op.image}
                                     style={op.style}
                                     key={index}/>
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

class WidgetOption extends React.Component {
  render() {
    const imageStyle = this.props.style || {};
    return (
      <div className={styles.option}
           onClick={() => this.props.onClick(this.props.widgetType, this.props.widgetSubType)}>
        <div>
          {
            this.props.image ? <img className="component-img" src={this.props.image}
                                    style={imageStyle}/> : null
          }
        </div>
        <div>{this.props.title}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/widget-list/widgetList.jsx